<template>
  <b-card header="Shipping" :header-bg-variant=bgVariant>
    <div v-if=noShipping>
      This order has no shipping!
    </div>
    <div v-if="!order.shippingAddress">
      Loading...
    </div>
    <div v-else>
      <address-info :address="order.shippingAddress" :is-shipping="true" />

      <div class='mt-2'>
        <div v-if=returnLabelCents>
          AndyMark Easy Return Label ({{returnLabelCents / 100 | formatDollars}})
        </div>
        <div v-else>
          <!-- <data-merger :dict=order.shippingCarrier title="Carrier" /> -->
          <span v-if="order.shippingMethod && order.shippingMethod.length > 0"> , </span>
          <data-merger :dict=order.shippingMethod title="Shipping Method" />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DataMerger from '../../utility/DataMerger.vue'
import orderMerger from '../../../services/orderMerge.js'
import AddressInfo from './AddressInfo.vue'

export default {
  data() {
    return {
    };
  },
  props: {
    order: { type: Object, required: true },
    returnLabelCents: { type: Number, default: 0 },
  },
  components: {
    DataMerger,
    AddressInfo,
  },
  computed: {
    ...mapGetters({
      countries: 'countries',
    }),
    bgVariant() {
      if (this.noShipping) {
        return 'warning'
      } else if (this.difference) {
        return 'danger'
      } else {
        return ''
      }
    },
    noShipping() {
      if (!this.order.shipping_address) {
        return false
      }
      return this.order.shippings.length > 0 && orderMerger.mergeField(this.shippingMethod) == "Online Delivery / No Shipping"
    },
    difference() {
      if (this.order.shippingAddress) {
        return Object.keys(this.order.shippingAddress).some((x) => {
          const dict = this.order.shippingAddress[x]
          if (!dict) return false
          if (Object.keys(dict) < 2) return false
          if (x === 'phoneNumber') return false


          return orderMerger.fieldDiffers(dict, true)
        });
      }
      return {}
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/ShippingAddress.vue